import type { QueryClient } from '@tanstack/react-query';
import type { UserDto } from '@/queries/user/user.schema';
import posthog from 'posthog-js';
import { QueriesKeys } from '@/queries/queriesKeys';

export const indentifyUser = (queryClient: QueryClient) => {
  const refreshedUser = queryClient.getQueryData<UserDto>([QueriesKeys.user]);

  if (refreshedUser?.id) {
    posthog?.identify(refreshedUser.id, {
      email: refreshedUser.email,
      registration_date: refreshedUser.createdAt,
    });

    // Ensures a person profile is created in identified_only mode.
    posthog?.createPersonProfile?.();
  }
};
